export default "__VITE_ASSET__Cn6rEU_b__"